import React from "react";
import "./Inner.css";

const accessories = ["Batteries", "Domes", "Receivers", "Cleaning kits", "Maintenance products"];
const followUp = ["Adjustments", "Counselling", "Routine reviews", "Device maintenance"];

export default function Services() {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>Services</span>
          <h1>How We Support Your Hearing</h1>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="card-grid">
            <div className="info-card">
              <h3>Hearing Assessments</h3>
              <p>Professional hearing evaluations conducted by qualified hearing care professionals.</p>
            </div>
            <div className="info-card">
              <h3>Hearing Aid Fitting</h3>
              <p>Personalized hearing aid selection, programming and fitting.</p>
            </div>
            <div className="info-card">
              <h3>Hearing Aid Financing</h3>
              <p>Flexible payment options available for eligible patients.</p>
            </div>
            <div className="info-card">
              <h3>Hearing Aid Accessories</h3>
              <div className="tag-list">
                {accessories.map((a) => <span className="tag" key={a}>{a}</span>)}
              </div>
            </div>
            <div className="info-card">
              <h3>Follow-up Care</h3>
              <div className="tag-list">
                {followUp.map((a) => <span className="tag" key={a}>{a}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
